import utils from '../utils';

function initScroll() {

	var images = utils.body.querySelectorAll('.scroll-image'),
		tmlGrab = false,
		tmlWheel = false;

	////// animated scroll left ///////
	function animScrollLeft(element, value, duration) {
		var rAF,
			startTime,
			startPos = element.scrollLeft,
			clientWidth = element.clientWidth,
			maxScroll = element.scrollWidth - clientWidth,
			scrollIntendedDestination = startPos + value,
			scrollEndValue = Math.min(Math.max(scrollIntendedDestination, 0), maxScroll),
			scroll = function (timestamp) {
				startTime = startTime || timestamp;
				var elapsed = timestamp - startTime;
				element.scrollLeft = startPos + (scrollEndValue - startPos) * (.5 * (Math.sin(((elapsed / duration) - .5) * Math.PI) + 1));
				if (elapsed <= duration) {
					rAF = window.requestAnimationFrame(scroll);
				}
				if (tmlGrab || tmlWheel) {
					window.cancelAnimationFrame(rAF);
				}
			}
		if (startPos != scrollEndValue) {
			rAF = window.requestAnimationFrame(scroll);
		}
	}

	function initDrag(photo) {

		// TODO da verificare come inibire per blocco imgfull

		if (photo) {

			//if (window.innerWidth > 768) {
				var startX,
					scrollLeft;

				photo.addEventListener('mousedown', function (e) {
					tmlGrab = true;
					photo.classList.add('is-grabbing');
					startX = e.pageX - photo.offsetLeft;
					scrollLeft = photo.scrollLeft;
					cancelMomentumTracking();
				});

				photo.addEventListener('mouseleave', function () {
					tmlGrab = false;
					photo.classList.remove('is-grabbing');
				});

				photo.addEventListener('mouseup', function () {
					tmlGrab = false;
					photo.classList.remove('is-grabbing');
					beginMomentumTracking();
				});

				photo.addEventListener('mousemove', function (e) {
					if (!tmlGrab) return;
					e.preventDefault();
					var x = e.pageX - photo.offsetLeft;
					var walk = x - startX;
					var prevScrollLeft = photo.scrollLeft;
					photo.scrollLeft = scrollLeft - walk;
					velX = photo.scrollLeft - prevScrollLeft;
				});

				var velX = 0,
					momentumID;

				photo.addEventListener('wheel', function (e) {
					cancelMomentumTracking();
					if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
						tmlWheel = true;
					}
				});

				function beginMomentumTracking() { // eslint-disable-line no-inner-declarations
					cancelMomentumTracking();
					momentumID = requestAnimationFrame(momentumLoop);
				}

				function cancelMomentumTracking() { // eslint-disable-line no-inner-declarations
					cancelAnimationFrame(momentumID);
				}

				function momentumLoop() { // eslint-disable-line no-inner-declarations
					photo.scrollLeft += velX;
					velX *= 0.95;
					if (Math.abs(velX) > 0.5) {
						momentumID = requestAnimationFrame(momentumLoop);
					}
				}

			// } else {
				photo.addEventListener('touchstart', function () {
					tmlGrab = true;
				});
			// }

		}

	}

	function startObserverScroll(image) {

        let scrollObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting || entry.intersectionRatio > 0) { //TODO change
                    var scrollImage = entry.target,
						totalScroll = scrollImage.scrollWidth, // quanto devo scrollare in totale
						timing = 14000; // 10sec

					animScrollLeft(scrollImage, totalScroll, timing);
					initDrag(scrollImage);

                    scrollObserver.unobserve(scrollImage);
                }
            });
        }, {
            rootMargin: '20% 0px 20% 0px',
            threshold: 0.5,
        });

		scrollObserver.observe(image);
    }

	utils.forEach(images, function (index, image) { //TODO es6
		startObserverScroll(image)
	});
	

}

export default { initScroll };